import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import ActionBar from '../../actionBar'
import PollTable from './PollTable'
import { fetchAttendancePollTemplates } from '../../../backend/backendApis'
import HttpService from '../../../backend/requestApis'
import AddPollTemplate from './AddPollTemplate'
import { useNavigate } from 'react-router-dom'
import Loader from '../../Loader'
import PollStats from '../PollStats/PollStats'

const PollTemplateScreen = () => {
  const navigate = useNavigate()

  const [addPollDialogStatus, setAddPollDialogStatus] = useState(false)
  const [templatesData, setTemplatesData] = useState([])
  const [isRefresh, setIsRefresh] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedPollForStats, setSelectedPollForStats] = useState(null)

  const updateAddPollDialogStatus = (refresh = false) => {
    setAddPollDialogStatus(!addPollDialogStatus)
    if (refresh) {
      setIsRefresh(!isRefresh)
    }
  }

  useEffect(() => {
    setIsLoading(true)
    let options = {
      url: fetchAttendancePollTemplates,
      method: 'GET',
      params: {},
      headers: {
        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
      }
    }

    HttpService(options).then((resp) => {
      setTemplatesData(resp?.data?.data || [])
      setIsLoading(false)
    }).catch(err => {
      console.log('Error in fetching poll templates: ', err)
      if (err?.status === 403 || err?.response?.status === 403) {
        localStorage.clear()
        navigate('/login')
      } else {
        setIsLoading(false)
      }
    })
  }, [isRefresh])

  return (
    <Box sx={{ height: 'calc(100vh - 50px)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {isLoading && <Loader />}
      {selectedPollForStats ? (
        <PollStats
          pollId={selectedPollForStats._id}
          pollDetails={selectedPollForStats}
          onBack={() => setSelectedPollForStats(null)}
        />
      ) : (
        <>
          <ActionBar
            dashBoard='Poll'
            updateAddPollDialogStatus={updateAddPollDialogStatus}
          />
          <PollTable
            data={templatesData}
            refreshTable={() => {
              setIsRefresh(!isRefresh)
            }}
            onViewStats={(pollRow) => {
              setSelectedPollForStats(pollRow)
            }}
            onAddNewPoll={() => updateAddPollDialogStatus()}
          />
          <AddPollTemplate
            dialogStatus={addPollDialogStatus}
            updateDialogStatus={updateAddPollDialogStatus}
          />
        </>
      )}
    </Box>
  )
}

export default PollTemplateScreen
